(() => {
  'use strict';
  const MAX_WEIGHT_KG = 20;
  const WARNING_ID = 'weight-variant-limit-warning';
  let timer = null;
  let lastState = '';

  const parseWeightKg = (value) => {
    if (!value) return 0;
    const text = String(value).trim().toUpperCase().replace(/,/g, '');
    let match = text.match(/([0-9]+(?:\.[0-9]+)?)\s*KG\b/);
    if (match) return Number(match[1]);
    match = text.match(/([0-9]+(?:\.[0-9]+)?)\s*G\b/);
    if (match) return Number(match[1]) / 1000;
    match = text.match(/([0-9]+(?:\.[0-9]+)?)\s*(?:LB|LBS|POUND|POUNDS)\b/);
    if (match) return Number(match[1]) * 0.45359237;
    return 0;
  };

  const getRoot = () => window.Shopify?.routes?.root || '/';
  const getCheckoutButtons = () => Array.from(document.querySelectorAll([
    'button[name="checkout"]','button#checkout','input[name="checkout"]',
    'button[type="submit"][name="checkout"]','button.cart__checkout-button',
    'a[href$="/checkout"]','a[href*="/checkout?"]'
  ].join(',')));

  const findMessageContainer = () => {
    const footer = document.querySelector('cart-drawer .drawer__footer, #CartDrawer .drawer__footer');
    if (footer) return footer;
    const drawer = document.querySelector('cart-drawer, #CartDrawer, .cart-drawer, .drawer');
    return drawer || document.body;
  };

  const getWarning = () => {
    let warning = document.getElementById(WARNING_ID);
    if (warning) return warning;
    warning = document.createElement('div');
    warning.id = WARNING_ID;
    warning.setAttribute('role', 'alert');
    warning.style.cssText = 'display:none;width:100%;box-sizing:border-box;flex:0 0 100%;margin:0 0 10px;padding:7px 10px;border:1px solid #e53935;border-radius:6px;background:#fff5f5;color:#c62828;font-size:12px;line-height:1.35;font-weight:500;text-align:center';
    const container = findMessageContainer();
    const ctas = container?.querySelector('.cart__ctas');
    if (ctas) container.insertBefore(warning, ctas);
    else if (container) container.appendChild(warning);
    return warning;
  };

  const calculate = async () => {
    const response = await fetch(getRoot() + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('Unable to read cart');
    const cart = await response.json();
    let total = 0;
    const countedItems = [];
    (cart.items || []).forEach((item) => {
      const options = Array.isArray(item.options_with_values) ? item.options_with_values : [];
      const weightOption = options.find((option) => option && String(option.name || '').trim().toLowerCase() === 'weight');
      if (!weightOption) return;
      const weightKg = parseWeightKg(weightOption.value);
      const quantity = Number(item.quantity) || 0;
      if (weightKg > 0 && quantity > 0) {
        const lineWeight = weightKg * quantity;
        total += lineWeight;
        countedItems.push({ title: item.product_title || item.title || '', value: weightOption.value, quantity, lineWeight });
      }
    });
    return { total, overLimit: total > MAX_WEIGHT_KG, countedItems };
  };

  const applyState = (result) => {
    const blocked = result.overLimit;
    const rounded = Number(result.total.toFixed(2));
    if (blocked) {
      const warning = getWarning();
      if (warning) {
        warning.style.display = 'block';
        warning.innerHTML = '⚠️ <strong>Orders above 20 KG are not accepted.</strong> Please reduce the quantity in your cart.';
      }
    } else {
      const warning = document.getElementById(WARNING_ID);
      if (warning) warning.style.display = 'none';
    }
    getCheckoutButtons().forEach((button) => {
      if (blocked) {
        button.dataset.weightLimitBlocked = 'true';
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.style.pointerEvents = 'none';
        button.style.cursor = 'not-allowed';
        button.style.opacity = '0.55';
      } else if (button.dataset.weightLimitBlocked === 'true') {
        button.disabled = false;
        button.removeAttribute('aria-disabled');
        button.style.pointerEvents = '';
        button.style.cursor = '';
        button.style.opacity = '';
        delete button.dataset.weightLimitBlocked;
      }
    });
    const state = blocked + '|' + rounded;
    if (state !== lastState) {
      lastState = state;
      window.dispatchEvent(new CustomEvent('namma:weight-limit-updated', { detail: { totalWeightKg: rounded, blocked } }));
    }
  };

  const check = async () => {
    try {
      const result = await calculate();
      applyState(result);
      if (window.Shopify?.designMode) console.info('[Weight limit]', result);
    } catch (error) {
      console.error('[Weight limit] Could not calculate cart weight:', error);
    }
  };

  const schedule = () => { clearTimeout(timer); timer = setTimeout(check, 250); };
  document.addEventListener('click', schedule, true);
  document.addEventListener('change', schedule, true);
  document.addEventListener('input', schedule, true);
  document.addEventListener('cart:updated', schedule);
  document.addEventListener('shopify:cart:lines-update', schedule);
  document.addEventListener('shopify:section:load', schedule);
  if (!window.__nammaWeightLimitObserver) {
    window.__nammaWeightLimitObserver = new MutationObserver(schedule);
    window.__nammaWeightLimitObserver.observe(document.body, { childList: true, subtree: true });
  }
  check();
})();